import React from 'react'
import { Separator } from '@fs/zion-ui'

import GraphicalHeaderBlock from '../GraphicalHeaderBlock/GraphicalHeaderBlock'
import Graphic from '../../assets/no-results-graphic.svg'
import transl from './NoResultsView.transl'

export default function NoResultsView({ heading = transl.defaultHeading, message = transl.defaultMessage }) {
  return (
    <>
      <GraphicalHeaderBlock src={Graphic} heading={heading} subHeading={message} />
      <Separator size="md" />
    </>
  )
}
